const Crypto = require('./Crypto')
module.exports = new Crypto()
